import { render } from "./QcEnquiry.vue?vue&type=template&id=b122fd12&scoped=true"
import script from "./QcEnquiry.vue?vue&type=script&lang=js"
export * from "./QcEnquiry.vue?vue&type=script&lang=js"

import "./QcEnquiry.vue?vue&type=style&index=0&id=b122fd12&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b122fd12"]])

export default __exports__